import Vue from 'vue'
import { MessageBox } from 'element-ui'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import App from './App'
import store from './store'
import { ls } from '@/utils/index'
// import { getToken } from '@/utils/auth'

import '@/styles/index.scss' // global css
import './icons' // icon
import { permsInit } from '@/permission' // permission control
import { patchVue } from '@/utils/patchVue'
import monitor from '@/utils/monitor'

import { i18n, loadLanguageAsync } from './i18n'
import initRouter from './router'

patchVue()
monitor()

;(async() => {
  // 从 localStorage 获取语言信息，如果没有默认是中文
  const lang = ls.getItem('lang', 'zh')
  await loadLanguageAsync(lang)
  const router = initRouter()
  await permsInit()

  await store.dispatch('GetInfo').then(() => {
    store.dispatch('GetNotice')
    store.dispatch('GetMarkdown')
  }).catch(error => {
    // 如果获取信息失败，可能是 token 失效，需要重新登录
    if (error.code === -401) {
      // 排除不需要登陆的页面
      const whiteList = ['/login', '/help', '/guide', '/404', '/ai_publish/index']
      if (whiteList.every(path => !window.location.pathname.startsWith(path))) {
        store.commit('login', true)
      }
    } else {
      MessageBox.alert(error.message, '异常', {
        type: 'error',
      })
    }
  })

  // eslint-disable-next-line
  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
  })
})()

// 热更新，正式环境不会执行
if (module.hot) {
  module.hot.accept(['./locales/en', './locales/zh'], function() {
    i18n.setLocaleMessage('en', require('./locales/en').default)
    i18n.setLocaleMessage('zh', require('./locales/zh').default)
  })
}
